import React from 'react';
import { useIsPalindrome } from '../../hooks/useIsPalindrome';
import CodeBlock from '../ui/CodeBlock';
import ResultBox from '../ui/ResultBox';
import TestCase from '../ui/TestCase';
import styles from './Exercise.module.css';

const CODE = `<span class="token-kw">function</span> <span class="token-fn">isPalindrome</span>(inputStr) {
  <span class="token-kw">let</span> left  = <span class="token-num">0</span>;
  <span class="token-kw">let</span> right = inputStr.length <span class="token-op">-</span> <span class="token-num">1</span>;

  <span class="token-cm">// Punteros desde ambos extremos hacia el centro</span>
  <span class="token-kw">while</span> (left <span class="token-op">&lt;</span> right) {
    <span class="token-kw">if</span> (inputStr[left] <span class="token-op">!==</span> inputStr[right]) {
      <span class="token-kw">return</span> <span class="token-num">false</span>;  <span class="token-cm">// diferencia encontrada</span>
    }
    left<span class="token-op">++</span>;
    right<span class="token-op">--</span>;
  }

  <span class="token-kw">return</span> <span class="token-num">true</span>;  <span class="token-cm">// todos los pares coincidieron</span>
}`;

function IsPalindromeExercise() {
  const { input, handleChange, result, isValid, testResults } = useIsPalindrome();

  const resultVariant = !isValid ? 'neutral' : result ? 'true' : 'false';
  const resultValue = isValid
    ? `isPalindrome("${input}") = ${result}`
    : null;

  return (
    <div className={styles.exercise}>
      <div className={styles.split}>
        <div className={styles.codeCol}>
          <p className={styles.colLabel}>Implementación</p>
          <CodeBlock code={CODE} />
        </div>

        <div className={styles.playCol}>
          <p className={styles.colLabel}>Prueba</p>

          <div className={styles.field}>
            <label className={styles.inputLabel} htmlFor="ip-input">
              Texto a verificar
            </label>
            <input
              id="ip-input"
              className={styles.input}
              type="text"
              placeholder="Ej: reconocer"
              value={input}
              onChange={(e) => handleChange(e.target.value)}
            />
            <span className={styles.hint}>Cualquier palabra o frase</span>
          </div>

          <ResultBox
            label="Resultado"
            value={resultValue}
            variant={resultVariant}
          />
        </div>
      </div>

      <div className={styles.tests}>
        <p className={styles.testsLabel}>Casos de prueba del enunciado</p>
        <div className={styles.testsList}>
          {testResults.map((tc) => (
            <TestCase
              key={tc.input}
              inputLabel={`"${tc.input}"`}
              expectedLabel={String(tc.expected)}
              actualLabel={String(tc.actual)}
              pass={tc.pass}
            />
          ))}
        </div>
      </div>
    </div>
  );
}

export default IsPalindromeExercise;
